module.exports = __webpack_public_path__ + "img/research-group-unused1.079fd36e.jpg";